/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/alt-text */
import { render, useEffect, useState } from '@wordpress/element';
import './index.css';
import data from './data.json';
import RaceRelationsContainer from './components/RaceRelations/RaceRelationsContainer';
import RacialInequalityContainer from './components/RacialInequality/RacialInequalityContainer';
import HoldingBackBlacks from './components/HoldingBackBlacks';
import FairTreatment from './components/FairTreatment';

// import 'semantic-ui-css/semantic.min.css';

const StateOfRaceInAmerica = () => {
    const [scrollY, setScrollY] = useState(0);

    const getScrollY = () => {
        console.log({ window });
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        console.log(data.discriminationPrejudice[0].note);
        window.addEventListener('scroll', getScrollY);
    }, [scrollY]);

    return (
        <div className="full-container flexBox">
            <div className="mobile-nav">
                <span className="title-text">
                    How blacks and whites view the state of race in America
                </span>
                <span
                    id="arrow"
                    style={{ fontSize: '30px', cursor: 'pointer' }}
                >
                    <img
                        id="down-arrow"
                        src="//assets.pewresearch.org/interactives/socialtrends/2016/interactive-state-of-race-in-america/icon_arrow_down_black_24px.svg"
                    />
                </span>
            </div>
            <div id="nav-test-a" className="nav-sidebar">
                <div className={`nav-wrapper ${250 < scrollY ? 'stuck' : ''}`}>
                    <ul className="toc">
                        <li className="nav-item">
                            <a
                                className="list-parent"
                                href="#views-on-race-relations"
                            >
                                Views of race relations
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="list-child" href="#race-relations">
                                Generally good or bad?
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="list-child" href="#how-to-improve">
                                How to improve: Focus on uniqueness or
                                commonalities?
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="list-child" href="#attention-to-race">
                                Attention to race: Too little or too much?
                            </a>
                        </li>
                    </ul>
                    <ul className="toc">
                        <li className="nav-item">
                            <a
                                className="list-parent"
                                href="#racial-inequality"
                            >
                                Racial Inequality
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="list-child" href="#give-equal-rights">
                                Changes needed to ensure racial equality?
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="list-child" href="#support-blm">
                                Support for Black Lives Matter movement
                            </a>
                        </li>
                    </ul>
                    <ul className="toc">
                        <li className="nav-item">
                            <a className="list-parent" href="#holding-back">
                                What may be holding blacks back?
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="list-child"
                                href="#racial-discrimination"
                            >
                                Racial discrimination
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="list-child"
                                href="#lower-quality-schools"
                            >
                                Lower quality schools
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="list-child"
                                href="#family-instability"
                            >
                                Family instability
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="list-child"
                                href="#discrimination-bigger-problem"
                            >
                                Bigger problem: Individual or institutional
                                discrimination?
                            </a>
                        </li>
                    </ul>
                    <ul className="toc">
                        <li className="nav-item">
                            <a className="list-parent" href="#treated-fairly">
                                Are blacks treated fairly?
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="list-child" href="#in-workplace">
                                In the workplace
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="list-child"
                                href="#dealing-with-police"
                            >
                                In dealing with police
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="list-child" href="#in-elections">
                                When voting in elections
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div id="container-test-a" className="interactive-container">
                <h1 className="true-title">
                    How blacks and whites view the state of race in America
                </h1>
                <p>
                    There are large gaps between blacks and whites in their
                    views of race relations and racial inequality in the United
                    States. Explore how the opinions of blacks and whites vary
                    by age, education, gender and party identification in key
                    questions from our report,"
                    <a href="http://www.pewsocialtrends.org/2016/06/27/on-views-of-race-and-inequality-blacks-and-whites-are-worlds-apart">
                        On Views of Race and Inequality, Blacks and Whites Are
                        Worlds Apart
                    </a>
                    ." These findings are from a new national survey of 3,769
                    U.S. adults, including 1,799 whites and 1,004 blacks,
                    conducted Feb. 29-May 8, 2016.
                </p>
                <RaceRelationsContainer />
                <RacialInequalityContainer />
                <HoldingBackBlacks />
                <FairTreatment />
            </div>

            {/* <div className="content-box">
                    <h3 id="racial-inequality">Racial inequality</h3>
                    <section id="give-equal-rights">
                        <p>
                            {' '}
                            Solid majorities of blacks across all demographic
                            groups say the country needs to continue making
                            changes to give blacks equal rights with whites.
                            While whites have moved closer to this position in
                            recent years, the share that agrees remains
                            significantly smaller (88% of blacks vs. 53% of
                            whites).{' '}
                        </p>
                        <div
                            id="g-RaceInteractiveSpecs_Trend-chart-box"
                            className="ai2html"
                        >
                            <div
                                id="g-RaceInteractiveSpecs_Trend-chart-Full_size"
                                className="g-artboard g-artboard-v3 "
                                data-min-width="640"
                            >
                                <div id="g-RaceInteractiveSpecs_Trend-chart-Full_size-graphic">
                                    {' '}
                                    <img
                                        id="g-ai0-0"
                                        className="g-aiImg"
                                        src="//assets.pewresearch.org/interactives/socialtrends/2016/interactive-state-of-race-in-america/RaceInteractiveSpecs_Trend-chart-Full_size.png"
                                    />
                                    <div
                                        id="g-ai0-1"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '-1.036%',
                                            left: '0.327%',
                                            width: '37.0%',
                                        }}
                                    >
                                        <p className="g-aiPstyle0">
                                            % among U.S. white adults saying ...
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai0-2"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '-1.036%',
                                            left: '55.503%',
                                            width: '37.0%',
                                        }}
                                    >
                                        <p className="g-aiPstyle0">
                                            % among U.S. black adults saying ...
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai0-3"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '13.8249%',
                                            right: '94.9254%',
                                            width: '5.0746%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">100%</p>
                                    </div>
                                    <div
                                        id="g-ai0-4"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '16.5899%',
                                            left: '96.1656%',
                                            width: '2.3524%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">88</p>
                                    </div>
                                    <div
                                        id="g-ai0-5"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '20.7374%',
                                            left: '55.9312%',
                                            width: '3.5937%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">81%</p>
                                    </div>
                                    <div
                                        id="g-ai0-6"
                                        className="g-Assets_Layer g-aiAbs"
                                        style={{
                                            top: '23.1567%',
                                            left: '13.708%',
                                            width: '26.6141%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">
                                            Our country has made the changes
                                            needed to give blacks equal rights
                                            with whites
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai0-7"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '31.106%',
                                            right: '96.3994%',
                                            width: '3.6006%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">75</p>
                                    </div>
                                    <div
                                        id="g-ai0-8"
                                        className="g-Assets_Layer g-aiAbs"
                                        style={{
                                            top: '34.9079%',
                                            left: '62.9854%',
                                            width: '27.3573%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">
                                            Our country needs to continue making
                                            changes to give blacks equal rights
                                            with whites
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai0-9"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '39.7466%',
                                            left: '6.1861%',
                                            width: '3.5937%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">54%</p>
                                    </div>
                                    <div
                                        id="g-ai0-10"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '41.1291%',
                                            left: '46.1978%',
                                            width: '2.5716%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">53</p>
                                    </div>
                                    <div
                                        id="g-ai0-11"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '48.3872%',
                                            right: '96.3994%',
                                            width: '3.6006%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">50</p>
                                    </div>
                                    <div
                                        id="g-ai0-12"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '52.5346%',
                                            left: '46.1978%',
                                            width: '2.5716%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">38</p>
                                    </div>
                                    <div
                                        id="g-ai0-13"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '52.8802%',
                                            left: '6.2224%',
                                            width: '2.5716%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">36</p>
                                    </div>
                                    <div
                                        id="g-ai0-14"
                                        className="g-Assets_Layer g-aiAbs"
                                        style={{
                                            top: '53.9171%',
                                            left: '62.7869%',
                                            width: '27.0676%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">
                                            Our country has made the changes
                                            needed to give blacks equal rights
                                            with whites
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai0-15"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '65.6683%',
                                            right: '96.3994%',
                                            width: '3.6006%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">25</p>
                                    </div>
                                    <div
                                        id="g-ai0-16"
                                        className="g-Assets_Layer g-aiAbs"
                                        style={{
                                            top: '67.3964%',
                                            left: '13.2672%',
                                            width: '29.0522%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">
                                            Our country needs to continue making
                                            changes to give blacks equal rights
                                            with whites
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai0-17"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '69.1245%',
                                            left: '56.0078%',
                                            width: '2.5716%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">13</p>
                                    </div>
                                    <div
                                        id="g-ai0-18"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '72.5807%',
                                            left: '96.938%',
                                            width: '1.4764%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">8</p>
                                    </div>
                                    <div
                                        id="g-ai0-19"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '82.9494%',
                                            right: '96.3994%',
                                            width: '3.6006%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">0</p>
                                    </div>
                                    <div
                                        id="g-ai0-20"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '87.4425%',
                                            left: '6.7991%',
                                            width: '6.0768',
                                            marginLeft: '-3.0384%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">NOV</p>
                                        <p className="g-aiPstyle4">2009</p>
                                    </div>
                                    <div
                                        id="g-ai0-21"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '87.4425%',
                                            left: '18.2053%',
                                            width: '6.0768',
                                            marginLeft: '-3.0384%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAR</p>
                                        <p className="g-aiPstyle4">2011</p>
                                    </div>
                                    <div
                                        id="g-ai0-22"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '87.4425%',
                                            left: '33.8999%',
                                            width: '6.0768',
                                            marginLeft: '-3.0384%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAR</p>
                                        <p className="g-aiPstyle4">2014</p>
                                    </div>
                                    <div
                                        id="g-ai0-23"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '87.4425%',
                                            left: '40.3062%',
                                            width: '6.0768',
                                            marginLeft: '-3.0384%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">JUL</p>
                                        <p className="g-aiPstyle4">2015</p>
                                    </div>
                                    <div
                                        id="g-ai0-24"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '87.4425%',
                                            left: '46.7905%',
                                            width: '7.4831',
                                            marginLeft: '-3.7415%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAY</p>
                                        <p className="g-aiPstyle4">2016</p>
                                    </div>
                                    <div
                                        id="g-ai0-25"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '87.4425%',
                                            left: '56.267%',
                                            width: '6.0768',
                                            marginLeft: '-3.0384%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">NOV</p>
                                        <p className="g-aiPstyle4">2009</p>
                                    </div>
                                    <div
                                        id="g-ai0-26"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '87.4425%',
                                            left: '67.6733%',
                                            width: '6.0768',
                                            marginLeft: '-3.0384%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAR</p>
                                        <p className="g-aiPstyle4">2011</p>
                                    </div>
                                    <div
                                        id="g-ai0-27"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '87.4425%',
                                            left: '83.3678%',
                                            width: '6.0768',
                                            marginLeft: '-3.0384%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAR</p>
                                        <p className="g-aiPstyle4">2014</p>
                                    </div>
                                    <div
                                        id="g-ai0-28"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '87.4425%',
                                            left: '89.7741%',
                                            width: '6.0768',
                                            marginLeft: '-3.0384%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">JUL</p>
                                        <p className="g-aiPstyle4">2015</p>
                                    </div>
                                    <div
                                        id="g-ai0-29"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '87.4425%',
                                            left: '96.2585%',
                                            width: '7.4831',
                                            marginLeft: '-3.7415%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAY</p>
                                        <p className="g-aiPstyle4">2016</p>
                                    </div>
                                </div>
                            </div>
                            <div
                                id="g-RaceInteractiveSpecs_Trend-chart-Mobile"
                                className="g-artboard g-artboard-v3 "
                                data-min-width="250"
                                data-max-width="639"
                            >
                                <div id="g-RaceInteractiveSpecs_Trend-chart-Mobile-graphic">
                                    <img
                                        id="g-ai1-0"
                                        className="g-aiImg"
                                        src="//assets.pewresearch.org/interactives/socialtrends/2016/interactive-state-of-race-in-america/RaceInteractiveSpecs_Trend-chart-Mobile.png"
                                    />
                                    <div
                                        id="g-ai1-1"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '-0.857%',
                                            left: '0%',
                                            width: '76.5625%',
                                        }}
                                    >
                                        <p className="g-aiPstyle0">
                                            % among U.S. white adults saying ...
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai1-2"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '6.6916%',
                                            right: '90.1991%',
                                            width: '10.4766%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">100%</p>
                                    </div>
                                    <div
                                        id="g-ai1-3"
                                        className="g-Assets_Layer g-aiAbs"
                                        style={{
                                            top: '11.839%',
                                            left: '24.5391%',
                                            width: '49.9445%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">
                                            Our country has made the changes
                                            needed to give blacks equal rights
                                            with whites
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai1-4"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '15.2706%',
                                            right: '93.2422%',
                                            width: '7.4335%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">75</p>
                                    </div>
                                    <div
                                        id="g-ai1-5"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '19.3885%',
                                            left: '10.8052%',
                                            width: '7.4194%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">54%</p>
                                    </div>
                                    <div
                                        id="g-ai1-6"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '20.2464%',
                                            left: '93.4101%',
                                            width: '5.309%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">53</p>
                                    </div>
                                    <div
                                        id="g-ai1-7"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '23.8496%',
                                            right: '93.2422%',
                                            width: '7.4335%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">50</p>
                                    </div>
                                    <div
                                        id="g-ai1-8"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '25.737%',
                                            left: '93.4101%',
                                            width: '5.309%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">38</p>
                                    </div>
                                    <div
                                        id="g-ai1-9"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '26.0801%',
                                            left: '10.8802%',
                                            width: '5.309%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">36</p>
                                    </div>
                                    <div
                                        id="g-ai1-10"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '32.4286%',
                                            right: '93.2422%',
                                            width: '7.4335%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">25</p>
                                    </div>
                                    <div
                                        id="g-ai1-11"
                                        className="g-Assets_Layer g-aiAbs"
                                        style={{
                                            top: '33.6296%',
                                            left: '22.8238%',
                                            width: '55.6076%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">
                                            Our country needs to continue making
                                            changes to give blacks equal rights
                                            with whites
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai1-12"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '41.0076%',
                                            right: '93.2422%',
                                            width: '7.4335%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">0</p>
                                    </div>
                                    <div
                                        id="g-ai1-13"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '43.0665%',
                                            left: '12.0708%',
                                            width: '12.5457',
                                            marginLeft: '-6.2728%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">NOV</p>
                                        <p className="g-aiPstyle4">2009</p>
                                    </div>
                                    <div
                                        id="g-ai1-14"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '43.0665%',
                                            left: '35.6192%',
                                            width: '12.5457',
                                            marginLeft: '-6.2728%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAR</p>
                                        <p className="g-aiPstyle4">2011</p>
                                    </div>
                                    <div
                                        id="g-ai1-15"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '43.0665%',
                                            left: '68.0209%',
                                            width: '12.5457',
                                            marginLeft: '-6.2728%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAR</p>
                                        <p className="g-aiPstyle4">2014</p>
                                    </div>
                                    <div
                                        id="g-ai1-16"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '43.0665%',
                                            left: '81.2467%',
                                            width: '12.5457',
                                            marginLeft: '-6.2728%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">JUL</p>
                                        <p className="g-aiPstyle4">2015</p>
                                    </div>
                                    <div
                                        id="g-ai1-17"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '43.0665%',
                                            left: '92.8901%',
                                            width: '15.4489',
                                            marginLeft: '-7.7245%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAY</p>
                                        <p className="g-aiPstyle4">2016</p>
                                    </div>
                                    <div
                                        id="g-ai1-18"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '50.7876%',
                                            left: '0.0274%',
                                            width: '76.5625%',
                                        }}
                                    >
                                        <p className="g-aiPstyle0">
                                            % among U.S. black adults saying ...
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai1-19"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '58.1655%',
                                            right: '90.1991%',
                                            width: '10.4766%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">100%</p>
                                    </div>
                                    <div
                                        id="g-ai1-20"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '59.5382%',
                                            left: '92.6985%',
                                            width: '4.8567%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">88</p>
                                    </div>
                                    <div
                                        id="g-ai1-21"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '61.5971%',
                                            left: '9.6339%',
                                            width: '7.4194%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">81%</p>
                                    </div>
                                    <div
                                        id="g-ai1-22"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '66.7445%',
                                            right: '93.2422%',
                                            width: '7.4335%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">75</p>
                                    </div>
                                    <div
                                        id="g-ai1-23"
                                        className="g-Assets_Layer g-aiAbs"
                                        style={{
                                            top: '70.3477%',
                                            left: '25.1266%',
                                            width: '56.4796%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">
                                            Our country needs to continue making
                                            changes to give blacks equal rights
                                            with whites
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai1-24"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '75.3235%',
                                            right: '93.2422%',
                                            width: '7.4335%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">50</p>
                                    </div>
                                    <div
                                        id="g-ai1-25"
                                        className="g-Assets_Layer g-aiAbs"
                                        style={{
                                            top: '79.0983%',
                                            left: '25.1266%',
                                            width: '59.478%',
                                        }}
                                    >
                                        <p className="g-aiPstyle2">
                                            Our country has made the changes
                                            needed to give blacks equal rights
                                            with whites
                                        </p>
                                    </div>
                                    <div
                                        id="g-ai1-26"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '83.9025%',
                                            right: '93.2422%',
                                            width: '7.4335%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">25</p>
                                    </div>
                                    <div
                                        id="g-ai1-27"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '85.6183%',
                                            left: '9.7921%',
                                            width: '5.309%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">13</p>
                                    </div>
                                    <div
                                        id="g-ai1-28"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '87.3341%',
                                            left: '94.2931%',
                                            width: '3.0481%',
                                        }}
                                    >
                                        <p className="g-aiPstyle3">8</p>
                                    </div>
                                    <div
                                        id="g-ai1-29"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '92.4815%',
                                            right: '93.2422%',
                                            width: '7.4335%',
                                        }}
                                    >
                                        <p className="g-aiPstyle1">0</p>
                                    </div>
                                    <div
                                        id="g-ai1-30"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '94.712%',
                                            left: '10.3271%',
                                            width: '12.5457',
                                            marginLeft: '-6.2728%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">NOV</p>
                                        <p className="g-aiPstyle4">2009</p>
                                    </div>
                                    <div
                                        id="g-ai1-31"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '94.712%',
                                            left: '33.8755%',
                                            width: '12.5457',
                                            marginLeft: '-6.2728%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAR</p>
                                        <p className="g-aiPstyle4">2011</p>
                                    </div>
                                    <div
                                        id="g-ai1-32"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '94.712%',
                                            left: '66.2772%',
                                            width: '12.5457',
                                            marginLeft: '-6.2728%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAR</p>
                                        <p className="g-aiPstyle4">2014</p>
                                    </div>
                                    <div
                                        id="g-ai1-33"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '94.712%',
                                            left: '79.503%',
                                            width: '12.5457',
                                            marginLeft: '-6.2728%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">JUL</p>
                                        <p className="g-aiPstyle4">2015</p>
                                    </div>
                                    <div
                                        id="g-ai1-34"
                                        className="g-Text_Layer g-aiAbs"
                                        style={{
                                            top: '94.712%',
                                            left: '92.8901%',
                                            width: '15.4489',
                                            marginLeft: '-7.7245%',
                                        }}
                                    >
                                        <p className="g-aiPstyle4">MAY</p>
                                        <p className="g-aiPstyle4">2016</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>
                            {' '}
                            Furthermore, blacks are far more skeptical than
                            whites that change will come – 43% say the country
                            will never make the necessary changes to achieve
                            racial equality, compared with 11% of whites. This
                            pattern holds across all demographic groups.
                        </p>
                                                            </section>

                                    */}
        </div>
    );
};

if (document.getElementById('js-state-of-race-in-america')) {
    render(
        <StateOfRaceInAmerica />,
        document.getElementById('js-state-of-race-in-america'),
    );
}
